import { IconButton, type IconButtonProps } from '@mui/material';
import { BackIcon } from 'components/icons';

type BackArrowProps = Omit<IconButtonProps, 'children' | 'sx'>;

const BackArrow = (props: BackArrowProps) => (
  <IconButton
    {...props}
    sx={{
      width: 18,
      minWidth: 18,
      height: 36,
      padding: 0,
      color: '#111827',
      justifyContent: 'flex-start',
      cursor: 'pointer !important',
      '& svg, & *': { cursor: 'pointer !important' },
      '&:hover, &:focus, &:active': { backgroundColor: 'transparent' },
    }}
  >
    <BackIcon />
  </IconButton>
);

export default BackArrow;
